import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";

export const TableSkeleton = ({ rows = 8 }) => (
  <div className="overflow-hidden rounded-xl border bg-card shadow-sm">
    <Table>
      <TableBody>
        {Array.from({ length: rows }).map((_, i) => (
          <TableRow key={i}>
            <TableCell className="w-10"><Skeleton className="h-4 w-4" /></TableCell>
            <TableCell><div className="flex items-center gap-2.5"><Skeleton className="h-8 w-8 rounded-full" /><div className="space-y-1.5"><Skeleton className="h-3.5 w-28" /><Skeleton className="h-2.5 w-20" /></div></div></TableCell>
            <TableCell><Skeleton className="h-3.5 w-24" /></TableCell>
            <TableCell><Skeleton className="h-3.5 w-28" /></TableCell>
            <TableCell className="hidden lg:table-cell"><Skeleton className="h-3.5 w-20" /></TableCell>
            <TableCell className="text-right"><Skeleton className="ml-auto h-4 w-16" /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
